import TicketStates from './TicketStatuses';
import TicketStatesProvider from './TicketStatusesContext';

let Index = () => {
    return (
        <>
        <TicketStatesProvider>
            <TicketStates />
        </TicketStatesProvider>
        </>

    )
}

export default Index;